/**
 * Normalizes a show name for sorting by removing "The " prefix
 */
export function normalizeShowName(name: string): string {
  const normalized = name.trim()
  if (normalized.toLowerCase().startsWith('the ')) {
    return normalized.slice(4).trim()
  }
  return normalized
}

/**
 * Custom comparison function for sorting shows by name
 * Ignores "The " prefix when sorting
 */
export function compareShowNames(a: string, b: string): number {
  const normalizedA = normalizeShowName(a)
  const normalizedB = normalizeShowName(b)
  return normalizedA.localeCompare(normalizedB, undefined, { sensitivity: 'base' })
}
